import { EmojiPickerDropdown } from "@/routes/app/-components/EmojiPickerDropdown"
import { Textarea, TextareaProps } from "@mantine/core"

interface Props extends Omit<TextareaProps, "onChange" | "value"> {
  onChange: (value: string) => void
  value: string
}

export function TextareaWithEmojiPicker({
  onChange,
  value,
  ...textareaProps
}: Props) {
  const ref = React.useRef<HTMLTextAreaElement>(null)
  return (
    <Textarea
      leftSection={
        <EmojiPickerDropdown
          position="top"
          focusTargetRef={ref}
          actionIconProps={{
            variant: "subtle",
            style: {
              pointerEvents: "all",
            },
          }}
          onSelect={(emoji) => {
            const cursorPosition = ref.current?.selectionStart ?? 0
            if (value) {
              const start = value?.slice(0, cursorPosition)
              const end = value?.slice(cursorPosition)
              onChange(start + emoji.emoji + end)
            }
          }}
        />
      }
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...textareaProps}
    />
  )
}
